import { useMemo, useState } from "react"
import { ExplodedPart } from "../types"

export type SortOption = "part_index_asc" | "part_index_desc" | "part_name_asc" | "part_name_desc"

export const useExplodedViewParts = (parts: ExplodedPart[]) => {
	const [searchTerm, setSearchTerm] = useState("")
	const [sortOption, setSortOption] = useState<SortOption>("part_index_asc")

	const activeParts = useMemo(() => parts.filter((p) => p.isActive === 1), [parts])

	const partsToDisplay = useMemo(() => {
		const term = searchTerm.trim().toLowerCase()
		let filtered = activeParts

		if (term !== "") {
			const byPartIndex = activeParts.filter((p) => String(p.partIndex).includes(term))
			filtered =
				byPartIndex.length > 0 ?
					byPartIndex
				:	activeParts.filter(
						(p) =>
							p.description?.toLowerCase().includes(term) ||
							p.partNumber?.toLowerCase().includes(term) ||
							(p.onlinePartId != null && String(p.onlinePartId).includes(term))
					)
		}

		return [...filtered].sort((a, b) => {
			switch (sortOption) {
				case "part_index_desc":
					return b.partIndex - a.partIndex
				case "part_name_asc":
					return (a.description ?? "").localeCompare(b.description ?? "")
				case "part_name_desc":
					return (b.description ?? "").localeCompare(a.description ?? "")
				default:
					return a.partIndex - b.partIndex
			}
		})
	}, [activeParts, searchTerm, sortOption])

	return { searchTerm, setSearchTerm, sortOption, setSortOption, partsToDisplay }
}
